export default String.raw`
{% if products.FilteringOptions.PriceFrom != null and products.FilteringOptions.PriceFrom > 0 -%}
    {% assign priceFromExists = true -%}
{% endif -%}
{% if priceFromExists or products.FilteringOptions.PriceTo != null -%}
    {% assign pricesExist = true -%}
{% else -%}
    {% assign pricesExist = false -%}
{% endif -%}  

{% if activeFiltersKeysString == "" or manufacturerOrBrandExists -%}
    {% assign showManufacturerOrBrand = true -%}
{% endif -%}

{% if products.HeaderData != null and showManufacturerOrBrand and pricesExist == false -%}
    {% if products.HeaderData.Image or products.HeaderData.Description != "" or products.HeaderData.Heading != "" -%}
        <div class="category-description">
            <div class="category-description__title-container">
                <span class="title">
                    {% if products.HeaderData.Heading != "" -%}
                        {{products.HeaderData.Heading}}
                    {% else -%}
                        {{page.CurrentSiteNode.Name}}
                    {% endif -%}
                </span>
                {% if products.TotalItems > 0 -%}
                    <span class="count">
                        ({{products.TotalItems}})
                    </span>
                {% endif -%}
            </div>
            {% if products.HeaderData.Description != "" or products.HeaderData.Image -%}
                <div class="category-description__container">
                    <div class="description-container">
                        <div class="description-container__category-name">
                            {% if products.HeaderData.Heading != "" -%}
                                {{products.HeaderData.Heading}}
                            {% else -%}
                                {{page.CurrentSiteNode.Name}}
                            {% endif -%}
                        </div>
                        {% if products.HeaderData.Description != "" -%}
                            <div class="description-container__description">
                                {{products.HeaderData.Description}}
                                {% if products.HeaderData.AiGeneratedDescription -%}
                                    <div class="ai-generated-content">{{ translations.AiGeneratedDescription }}</div>
                                {% endif -%}
                            </div>
                        {% endif -%}
                    </div>
                    {% if products.HeaderData.Image -%}
                        <div class="image-container">
                            {{products.HeaderData|Img:'medium'}}
                        </div>
                    {% endif -%}
                </div>
            {% endif -%}
        </div>
    {% endif -%}
{% endif -%}
`